module.exports = __webpack_public_path__ + "static/media/search-image.6d2ce063.svg";